import React, { useEffect, useRef, useState } from "react";
import { message } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import {
  flyertLevelMatch,
  flyertVipInfo,
  loginStatus,
  myInfo,
  wechatGenerateScheme,
} from "../../../api";
import "./style.scss";

const images = {
  cover: "https://staticfile.badazhou.com/20260529/5e57ba773de40d39967aa6b9115c1aad.jpeg",
  ruleChecked: "https://staticfile.badazhou.com/20260529/c4ab24acd506cc7ad84e1cae5ca95746.jpeg",
  ruleUnchecked: "https://staticfile.badazhou.com/20260529/6fad6d2decad8fd0279dfb7bba694e12.jpeg",
  intro: "https://staticfile.badazhou.com/20260529/44b84f51159d1fbad3ede96b5dcf83de.jpeg",
  action: "https://staticfile.badazhou.com/20260529/6e1e4d70ea79f9003cc70b97514c2607.jpeg",
  matchedAction: "https://staticfile.badazhou.com/20260601/ec2e6be7bd467bd79c53859597771047.jpeg",
  benefits: "https://staticfile.badazhou.com/20260529/1c6d08f7cef8117eea04b7f8df1ae626.jpeg",
  hotelA: "https://staticfile.badazhou.com/20260529/17c8c344012066c630448550f8fc575f.jpeg",
  hotelB: "https://staticfile.badazhou.com/20260529/62f3fba3167955daff67ca4e08eedf4b.jpeg",
  rules: "https://staticfile.badazhou.com/20260529/fc87c19de7eaab9e92dff457c55127b0.jpeg",
  footer: "https://staticfile.badazhou.com/20260529/d1452ffa98ae07deff0ea2c10c3204af.jpeg",
};

function getUidFromSearch(search) {
  const query = search.charAt(0) === "?" ? search.substr(1) : search;
  const uidParam = query.split("&").find((item) => item.split("=")[0] === "uid");
  if (!uidParam) return "";

  const value = uidParam.substr(uidParam.indexOf("=") + 1);
  try {
    return decodeURIComponent(value).replace(/ /g, "+");
  } catch (error) {
    return value.replace(/ /g, "+");
  }
}

export default () => {
  const [agreed, setAgreed] = useState(false);
  const [matched, setMatched] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const schemeRef = useRef(null);
  const history = useHistory();
  const { search } = useLocation();

  const uid = getUidFromSearch(search);

  useEffect(() => {
    loginStatus().then((res) => {
      if (!res.data.loginStatus) {
        const redirect = `${window.location.pathname}${window.location.search}`;
        history.push(`/login?redirect=${encodeURIComponent(redirect)}`);
        return;
      }

      myInfo().then((infoRes) => {
        setUserInfo(infoRes.data);
      }).catch(() => { });

      if (!uid) {
        message.error("缺少用户参数");
        return;
      }

      flyertVipInfo({ uid }).then((infoRes) => {
        setMatched(Number(infoRes.data?.matched) === 1);
      }).catch(() => { });
    }).catch(() => {
      const redirect = `${window.location.pathname}${window.location.search}`;
      history.push(`/login?redirect=${encodeURIComponent(redirect)}`);
    });

    const randomNum = parseInt(Math.random() * 100000000);
    wechatGenerateScheme({
      path: "/pages/myCenter/myCenter",
      query: `randomNum=${randomNum}`,
    }).then((res) => {
      schemeRef.current = res.data;
    }).catch(() => { });
  }, [history, uid]);

  const goToMiniProgram = () => {
    if (schemeRef.current?.scheme) {
      window.location.href = schemeRef.current.scheme;
    }
  };

  const handleMatch = () => {
    if (matched) return;
    if (!agreed) {
      message.error("请先勾选活动规则");
      return;
    }
    if (!uid) {
      message.error("缺少用户参数");
      return;
    }
    if (!userInfo?.phone) {
      message.error("未获取到手机号，请重新登录后再试");
      return;
    }
    if (submitting) return;

    setSubmitting(true);
    const areaCode = ["86", "1"].includes(userInfo.areaCode) ? userInfo.areaCode : "86";
    flyertLevelMatch({
      area_code: areaCode,
      phone: userInfo.phone,
      uid,
    }).then((res) => {
      if (res.code === "200000") {
        setMatched(true);
        message.success("匹配成功");
        goToMiniProgram();
      } else {
        message.error(res.msg || "匹配失败，请稍后再试");
      }
    }).catch(() => {
      message.error("匹配失败，请稍后再试");
    }).finally(() => {
      setSubmitting(false);
    });
  };

  return (
    <div className="visa-club8-page">
      <img src={images.cover} alt="" />
      <button
        type="button"
        className="rule-toggle"
        aria-label={(agreed || matched) ? "取消同意本活动规则" : "同意本活动规则"}
        aria-pressed={agreed || matched}
        onClick={() => {
          if (!matched) {
            setAgreed(!agreed);
          }
        }}
      >
        <img src={(agreed || matched) ? images.ruleChecked : images.ruleUnchecked} alt="" />
      </button>
      <img src={images.intro} alt="" />
      <button
        type="button"
        className="action-button"
        aria-label={matched ? "已经参与过活动" : "立即参与活动"}
        onClick={handleMatch}
        disabled={matched || submitting}
      >
        {matched ? (
          images.matchedAction ? (
            <img src={images.matchedAction} alt="" />
          ) : (
            <span>已经参与过活动</span>
          )
        ) : (
          <img src={images.action} alt="" />
        )}
      </button>
      <img src={images.benefits} alt="" />
      <img src={images.hotelA} alt="" />
      <img src={images.hotelB} alt="" />
      <img src={images.rules} alt="" />
      <img src={images.footer} alt="" />
    </div>
  );
};
